/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CHECK_PAYMENT_FROM_FAC } from "../graphql/checkoutFAC.mutation";
import { VApplication } from "../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { CREATE_BOX } from "../graphql/createBox.mutation";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const is = require("is_js");

const buildAllocations = (items: any[], totalAmount: number) => {
  if (!items || items.length === 0) return [];
  const eachAmount = parseFloat((totalAmount / items.length).toFixed(2));
  let sum = 0;
  const list = items.map((item, idx) => {
    const costumeValueId = item?.costumeValue?.id || item?.costumeValue;
    const isLast = idx === items.length - 1;
    const amount = isLast
      ? parseFloat((totalAmount - sum).toFixed(2))
      : eachAmount;
    sum += amount;
    return { costumeValueId, amount };
  });
  return list;
};

export interface CreatePayFACProps {
  amount: number;
  currency?: string;
  notes?: string;
  payOrder?: boolean;
  mode?: string;
}
export interface ICreatePayFACMethods extends IPluginMethodMap {
  createPayFAC(args: any): Promise<any>;
}

export class CreatePayFACService implements IAgentPlugin {
  readonly methods: ICreatePayFACMethods;

  constructor() {
    this.methods = {
      createPayFAC: this.createPayFAC.bind(this),
    };
  }

  async createPayFAC(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_BOX,
          variables: {
            data: {
              presentation: args?.presentationID,
              section: args?.sectionID,
              items: args?.items,
            },
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.createBox && is.existy(res?.data?.createBox)) {
          console.log(res?.data?.createBox);
          if (args?.mode === "online") {
            const dateStr = args?.event?.doe;
            const date = new Date(dateStr);
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const yyMM =
              (year % 100).toString().padStart(2, "0") +
              month.toString().padStart(2, "0");
            const res = await client.mutate({
              mutation: CHECK_PAYMENT_FROM_FAC,
              variables: {
                data: {
                  cardDetail: {
                    cardExp: yyMM,
                    cardHolderName: args?.event?.holderName,
                    cardPan: args?.event?.cardPan,
                    cvv: args?.event?.cvv,
                  },
                  currency: args?.event?.currency,
                  // tax: uuidv4(),
                  totalAmount: parseFloat(args?.event?.amount),
                  payOrder: args?.payOrder?.id,
                  platformFee: args?.event?.platformFee ? parseFloat(args?.event?.platformFee) : 0,
                  allocations: args?.event?.allocations ?? [],
                }
              },
              fetchPolicy: "no-cache",
            });
            if (res?.data) {
              return {
                ...res?.data,
              };
            }
          }
        } else {
          return res?.data?.createBox;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
    }
  }
}
